<template>
  <div class="popup-content animated zoomIn photo-com">
    <div class="popup-title flex"><span>{{ title }}</span><img width="20px"
        :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'"
        @click="togglePopup(togglePopupValues[0], togglePopupValues[1], togglePopupValues[2], togglePopupValues[3])" />
    </div>
    <div class="btn btn-emphasis inputFileHidden">
      <span class="img-container">
        <img :id="'edit_photo1' + id" width="150" :src="photo" />
        <img class="img-ico" :src="fit20.storageBaseUrl + '/static/icons/%2Bfoto.svg'" />
      </span>
      <input name="image" type="file" class="form-control" accept="image/*" capture="camera" @change="changePhoto">
    </div>
    <div class="btn-container">
      <img class="new-session-btn" width="60px" :src="fit20.storageBaseUrl + '/static/icons/save.png'"
        @click="savePhoto">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Photo',
  props: ["title", "id", "photo", "changePhoto", "togglePopup", "savePhoto", "togglePopupValues", "newPhoto", "fit20"],
}
</script>
<style>
.photo-com .img-container img {
  border-radius: 15px;
  cursor: pointer;
  margin-top: 10px;
  margin-left: 15px;
}
</style>
